<section
	class="ctb-carousel"
	[attr.aria-label]="state().ariaLabel || state().label"
	[attr.id]="state().id"
>
	@if (state().label !== "") {
		<h2 class="ctb-carousel__label">{{ state().label }}</h2>
	}
	<div class="ctb-carousel__track" aria-live="polite">
	<div
		class="ctb-carousel__items"
		[class.ctb-carousel__items--has-left-peek]="hasLeftPeek() && !hasBothPeeks()"
		[class.ctb-carousel__items--has-both-peeks]="hasBothPeeks()"
	>
	@for (thumbnail of visibleThumbnails(); track thumbnail.id) {
		<button
			class="ctb-carousel__item"
			type="button"
			[attr.aria-label]="thumbnail.title"
			[attr.aria-pressed]="state().selectedId === thumbnail.id"
			[class.ctb-carousel__item--selected]="state().selectedId === thumbnail.id"
			(click)="onThumbnailSelect(thumbnail.id)"
		>
			<span class="ctb-carousel__item-title">{{ thumbnail.title }}</span>

			<span class="ctb-carousel__item-image-wrapper">
				<img
					alt=""
					class="ctb-carousel__item-image"
					[src]="thumbnail.imageUrl"
				/>

				@if (thumbnail.overlayNote !== undefined) {
					<span aria-hidden="true" class="ctb-carousel__item-overlay">{{ thumbnail.overlayNote }}</span>
				}
			</span>
		</button>
	}
	</div>
	</div>
	

	<nav class="ctb-carousel__dots" [attr.aria-label]="'Navigation — ' + (state().ariaLabel || state().label)">
		@for (thumbnail of state().thumbnails; track thumbnail.id; let i = $index) {
			<button
				class="ctb-carousel__dot"
				type="button"
				[attr.aria-label]="'Aller à ' + thumbnail.title"
				[attr.aria-current]="activeDotIndex() === i ? true : null"
				[class.ctb-carousel__dot--active]="activeDotIndex() === i"
				(click)="onDotClick(i)"
			></button>
		}
	</nav>
</section>